// import { useEffect, useState } from "react";
// import { useCookies } from 'react-cookie';
import { Navigate } from "react-router-dom";

const InvestorProtectedRoute = ({ Component }: any) => {
  const token: any = localStorage.getItem("investor-access-token");
  return token?.length > 0 ? (
    <Navigate to={"/investor/properties-listing"} />
  ) : (
    <Component />
  );
};

export default InvestorProtectedRoute;
